// extracted by css-extract-rspack-plugin
export default {"divider":"HQNt5ABk6Vcv_M83"};